import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as fromUnitsAction from '@ordersnproducts/modules/order-builder/modules/location-specification/actions/unit-actions/units.action';
import { UnitsOfMeasurement } from '../../models/order-management/units-of-measurement.model';

export interface State extends EntityState<UnitsOfMeasurement> {
  selectedUnitId: number | null;
}

export const adapter: EntityAdapter<UnitsOfMeasurement> = createEntityAdapter<UnitsOfMeasurement>({
  selectId: ($unit: UnitsOfMeasurement) => $unit.id,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedUnitId: null,
});

export function reducer(state = initialState, action: fromUnitsAction.Actions): State {
  switch (action.type) {
    case fromUnitsAction.ActionTypes.ADD_UNITS: {
      return adapter.addMany(action.payload.units, { ...state });
    }
    case fromUnitsAction.ActionTypes.CLEAR_UNITS: {
      return adapter.removeAll(state);
    }
    case fromUnitsAction.ActionTypes.FETCH_UNITS:
    case fromUnitsAction.ActionTypes.NO_ACTION:
    default: {
      return state;
    }
  }
}

export const getEntities = (state: State) => state.entities;

export const getUnits = (state: State) => {
  const units: UnitsOfMeasurement[] = Object.keys(state.entities).map(i => state.entities[i]);
  return units;
};
